module.exports = __webpack_public_path__ + "assets/img/footer-blob-top-right.a34cd2ed.webp";